var tabRef;
var url = new URL(window.location.href);
console.log("url", url);
var arr = url.href.split('?');
if (url.href.includes('?')) {
  var tabRef = url.searchParams.get("tab");
  this.tabRef = tabRef;
  console.log("tabRef", tabRef, this.tabRef);
  setTimeout(() => {
    if ((tabRef === "null") || (tabRef == null) || ((tabRef === ""))) {
    } else {
      switch(tabRef) {
        case "iverson-01":
          {
            changeTab("2");
            break;
          }
          
        case "iverson-96":
          {
            changeTab("1");
            break;
          }
          
        default:
        {
          break;
        }
      }
      
    }
  }, 1500);
} else {
}
function changeTab(tabs) {
  console.log("changeTab", tabs);
  let tab = document.getElementsByClassName("tab-content");
  let tabContent = document.getElementsByClassName("tabs-content");
  if (null != tab) {
    var count = 1;
    for (let tb of tab) {
      if (String(count) === tabs) {
        tb.style.visibility = "visible";
        tb.style.display = "block";
      } else {
        tb.style.visibility = "hidden";
        tb.style.display = "none";
      }
      
      if (String(tabs) === String(2)) {
      	initMapTwo();
        let zipInput = document.getElementById("zip-code-inputTwo");
        if (null != zipInput) {
        	zipInput.value = "";
        }
      }
      
      if (String(tabs) === String(1)) {
      	initMap();
        let zipInput = document.getElementById("zip-code-input");
        if (null != zipInput) {
        	zipInput.value = "";
        }
      }
      count += 1;
    }
  }
  
  if (null != tabContent) {
    var count = 1;
  	for (let tb of tabContent) {
      if (String(count) === tabs) {
        tb.style.background = "#8e44ad";
      } else {
        tb.style.background = "#512179";
        tb.style.fontWeight = "600";
      }

      count += 1;
    }
  }
}